import { render } from "./PageSetting.vue?vue&type=template&id=5b34a175"
import script from "./PageSetting.vue?vue&type=script&lang=js"
export * from "./PageSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__